import {
    ActionService,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";
import {inject, Injectable} from "@angular/core";
import {AppDeviceType} from "../configuration/configuration.model";

export class AppDeviceRegistrationRequestData extends EntityData<AppDeviceRegistrationRequestData> {
    @field deviceId: string;
    @field deviceType: AppDeviceType;
    @field secret: string;
}

/**
 * Service to register an AppDevice with the server.
 */
@Injectable({providedIn: "root"})
export class AppDeviceRegistrationService extends ActionService {

    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- AppDeviceRegistrationService");

        super(http, nameSpace, "app-device-registration", configService, useAsync, actionNames);
    }
}
